/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {injectIntl} from "react-intl";
import {withRouter} from "react-router";
import {Table, Checkbox} from '@scuf/common';
import connect from "react-redux/es/connect/connect";
import {getAllUIconfigs, setUIconfig} from '../api/UIconfig'

class UIconfigAdminDashBoard extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            allConfigs: null,
        }
        this.getUIconfigElements = this.getUIconfigElements.bind(this)
        this.getRowClass = this.getRowClass.bind(this)
    }

    componentDidMount() {
        getAllUIconfigs().then((response) => {
            this.setState({allConfigs: response})
        })
    }

    getRowClass(className, index) {
        return className + ' ' + (index % 2 === 0 ? 'even' : 'odd')
    }

    getUIconfigElements(UIconfigs) {
        return UIconfigs.map((c, i) => {
            return (
                <Table.Row className={this.getRowClass("config-row", i)}>
                    <Table.Cell>
                        {c.description}
                    </Table.Cell>
                    <Table.Cell>
                        <Checkbox
                            toggle={true}
                            checked={c.status === 'ACTIVE'}
                            onChange={() => {
                                setUIconfig(c.name, c.status === 'ACTIVE' ? 'DISABLED' : 'ACTIVE').then((response) => {
                                    this.setState({allConfigs: response})
                                })
                            }}
                        />
                    </Table.Cell>
                </Table.Row>
            )
        })
    }

    render() {
        const UIconfigs = this.state.allConfigs == null ? null : this.getUIconfigElements(this.state.allConfigs)
        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.HeaderCell content="UI functionality"/>
                        <Table.HeaderCell content="State"/>
                    </Table.Header>
                    <Table.Body>
                        {UIconfigs}
                    </Table.Body>
                </Table>
            </div>
        )
    }
}

export default injectIntl(withRouter(connect(null, null)(UIconfigAdminDashBoard)))
